import { render } from "./Register_health_other3.vue?vue&type=template&id=32b9a6fe&scoped=true"
import script from "./Register_health_other3.vue?vue&type=script&lang=js"
export * from "./Register_health_other3.vue?vue&type=script&lang=js"

import "./Register_health_other3.vue?vue&type=style&index=0&id=32b9a6fe&scoped=true&lang=css"

import exportComponent from "B:\\GitHub\\Nakronpao\\Nakronpao-health\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b9a6fe"]])

export default __exports__